import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { successOf } from '@zerops/zef/entities';
import { UserTokenEntity, UserTokenCreateResponse } from '../../core/user-token-base';
import { IntegrationTokenEntity, integrationTokenActions } from '../../core/integration-token-base';
import { FEATURE_NAME } from './token-display-dialog.constant';
import { IntegrationTokenWithSecret } from '@zerops/models/integration-token';

@Injectable()
export class TokenDisplayDialogEffect {
  #actions$ = inject(Actions);
  #userTokenEntity = inject(UserTokenEntity);
  #integrationTokenEntity = inject(IntegrationTokenEntity);

  /**
   * Opens token display dialog when user token is created successfully.
   */
  onUserTokenCreatedShowToken$ = createEffect(() =>
    this.#actions$.pipe(
      successOf(this.#userTokenEntity.addOne),
      map(({ meta }) => {
        const token = meta.rawResult as UserTokenCreateResponse;
        return zefDialogOpen({
          key: FEATURE_NAME,
          meta: {
            name: token.name,
            token: token.token,
            isPersonal: true
          }
        });
      })
    )
  );

  /**
   * Opens token display dialog when integration token is created successfully.
   */
  onIntegrationTokenCreatedShowToken$ = createEffect(() =>
    this.#actions$.pipe(
      successOf(this.#integrationTokenEntity.addOne),
      map(({ meta }) => {
        const token = meta.rawResult as IntegrationTokenWithSecret;
        return zefDialogOpen({
          key: FEATURE_NAME,
          meta: {
            name: token.name,
            token: token.token
          }
        });
      })
    )
  );

  /**
   * Opens token display dialog when integration token is regenerated successfully.
   */
  onIntegrationTokenRegeneratedShowToken$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(integrationTokenActions.regenerateTokenSuccess),
      map(({ data }) =>
        zefDialogOpen({
          key: FEATURE_NAME,
          meta: {
            name: data.name,
            token: data.token,
            isRegenerate: true
          }
        })
      )
    )
  );
}
